<template>
    <div class="McfBgImg d-lg-none" :style="{background: `url(${headerBackground}) no-repeat top center`}"></div>
</template>

<script>
export default {
  props: {
    headerBackground: {
      type: String,
    },
  },
};
</script>

<style scoped>
.McfBgImg {
  top: 0;
  z-index: 1;
  background-size: cover !important;
  width: 100%;
  height: 100%;
  min-height:48px;
  transform:scale(1.25);
  -webkit-filter: brightness(.5) blur(4px);
  filter: brightness(.5) blur(4px);
}
</style>
